import { Text, Tooltip } from "@mantine/core"
import clsx from "clsx"
import styles from "./styles.module.css"
import { SimpleFormulaDto } from "../../../../../orval/gen"

const orientation = "normal"

export function FormulaHeaderCell({
  formula,
  style,
}: {
  formula: SimpleFormulaDto
  style: React.CSSProperties
}) {
  return (
    <div className={clsx(styles["cell"], styles["header"])} style={style}>
      <Tooltip label={formula.name} withArrow>
        <Text
          size={"xs"}
          style={
            orientation === "normal"
              ? {
                  writingMode: "vertical-lr",
                  transform: "rotate(-180deg)",
                }
              : undefined
          }
        >
          {formula.code}
        </Text>
      </Tooltip>
    </div>
  )
}
